import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { finalizeLoader } from '@app/shared/components';
import { coursesActions } from '../actions/courses.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class CoursesEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getCourses$ = createEffect(() => {
        return this.actions.pipe(
            ofType(coursesActions.getCourses),
            mergeMap(({ value }) => {
                return this.httpService.getCourses(value).pipe(
                    finalizeLoader('courses-list'),
                    map(({ payload, total }) => coursesActions.getCoursesSuccess({ payload, total })),
                    catchError((response: HttpErrorResponse) => of(coursesActions.getCoursesError({ code: response.status }))),
                );
            }),
        );
    });
}
